import { MetricConfig } from '@/types/evals';
import { getMetricType } from '@/utils/metricUtils';

import { InfoCard } from '../../_components/InfoCard';
import { InfoCardRow } from '../../_components/InfoCardRow';

type Props = {
  config: MetricConfig;
};

export function MetricMetaRow( { config }: Props ) {
  const { configuration } = config;

  return (
    <InfoCardRow data-testid="metric-meta-row">
      <InfoCard label="Metric Type" value={ getMetricType( configuration ) } />
      { 'model_parameters' in configuration && (
        <>
          <InfoCard label="Model Name" value={ configuration.model_parameters.model } />
          <InfoCard label="Model Temperature" value={ configuration.model_parameters.temperature } />
        </>
      ) }
      { 'url' in configuration && (
        <InfoCard
          label="Async Metric"
          value={ configuration.is_async === undefined ? '—' : String( configuration.is_async ) }
        />
      ) }
      <InfoCard label="Example Types" value={ config.example_type?.join( ', ' ) ?? '—' } />
    </InfoCardRow>
  );
}
